import ScheduleTimeline from '../components/ScheduleTimeline';

const SchedulePage = () => {
  return <ScheduleTimeline />;
};

export default SchedulePage;